export const getSoundUrl = (soundName) => {
  if (!soundName) return null;

  const baseUrl = process.env.BACKEND_URL?.replace("/api", "");
  return `${baseUrl}/public/sounds/${soundName}`;
};
